/**
 * @author mll
 * 2020-04-29
 * 考试模版组查看
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool, utils_tool } from '@/tool';
import { AudienceGroupItem } from '@/components';
let { WizContainer, modelUtils } = framework_tool;
let { WizCard, WizCol, WizRow, WizTypography, WizTable, WizSurveyAudience, WizSpin } = component_tool
let { Session } = utils_tool
let { Paragraph } = WizTypography

const getParamRecord = (history) => {
    let record = {}
    if (history.location) {
        if (history.location.pathname === '/online/examTemplateGroup/examTemplateGroupInfo') {
            if (history.location && history.location.record) {
                record = history.location.record
                Session.set('examTemplateGroupInfo', record)
            } else {
                record = Session.get('examTemplateGroupInfo') || {}
            }
        }
    }
    return record
}

class ExamTemplateGroupInfo extends WizContainer {
    componentName = 'ExamTemplateGroupInfo';

    constructor(props) {
        super(props)
        this.state = {
            record: getParamRecord(props.history)
        }
    }

    _componentWillMount = () => {
        this._getAuthInfo()
    };

    /**
     * 获取权限数据
     */
    _getAuthInfo = () => {
        let { record } = this.state;
        if (record && record['id']) {
          this.doActions([{
            path: "examTemplateGroup/getExamTemplateGroupById",
            payload: {
              key: "templateAuthInfoKey",
              apiParams: {
                id: record['id']
              },
            },
          }]);

        }
    }

    propsAndStateOnChange = {
        templateAuthInfo: this._templateAuthInfo.bind(this),
    };


    _templateAuthInfo(nextProps, nextState) {
    let { templateAuthInfo } = nextProps;
    if (templateAuthInfo && templateAuthInfo["success"]) {
      nextState.templateAuthInfo = templateAuthInfo["data"]
      return true;
    } else {
      wizNotice.error((templateAuthInfo && templateAuthInfo["msg"]) || "获取权限数据失败,请稍后尝试");
    }
    return false;
  }
    /**
     * 详细信息
     */
    _info = (v) => {
        return (
            <WizCard key={'_info'} title='模版组信息' icon='0'>
                <WizRow>
                    <WizCol span={10}>{this._info_col('模版组名称', v['title'])}</WizCol>
                    <WizCol span={10}>{this._info_col('状态', v['status'] === 1 ? '有效' : '无效')}</WizCol>
                </WizRow>
                <WizRow>
                    <WizCol span={10}>{this._info_col('考试分类', v['categoryType'])}</WizCol>
                    <WizCol span={10}>{this._info_col('考试时长', v['limitMinutes'] || 0 + ' 分钟')}</WizCol>
                </WizRow>
                <WizRow>
                    <WizCol span={10}>{this._info_col('允许重复考试', v['count'] || 0 + ' 次')}</WizCol>
                </WizRow>
            </WizCard>
        )
    }

    _info_col = (k, v) => {
        return (
            <WizRow>
                <WizCol span={10}><Paragraph style={{ textAlign: 'right' }}>{k}:</Paragraph></WizCol>
                <WizCol span={12} offset={1}><Paragraph>{v}</Paragraph></WizCol>
            </WizRow>
        )
    }

    /**
     * 受众
     */
    _target = (authInfo) => {
        return <WizCard key={'_target'} title='模版组受众' icon='0'>
            {/* <WizSurveyAudience labelWidth={4} data={authInfo || {}} /> */}
            <AudienceGroupItem { ...authInfo } />
        </WizCard>
    }

    /**
     * 关联模版
     */
    _links = (v) => {
        let columns = [
            { title: '考试模版组名称', dataIndex: 'title', key: 'title' },
            { title: '岗位对象', dataIndex: 'position', key: 'position' }
        ]
        let dataSource = [];
        v && v.length && v.forEach(e => {
            let position = ''
            if (e['positionRows'] && e['positionRows'].length) {
                e['positionRows'].forEach(p => {
                    if (position === '') {
                        position += `${p['positionBrandName']}`
                    } else {
                        position += `,${p['positionBrandName']}`
                    }

                });
            }
            dataSource.push({
                key: e['templateId'],
                title: e['templateName'],
                position
            })
        });
        return (
            <WizCard key={'_links'} title='关联考试模版' icon='0'>
                <WizRow>
                    <WizCol offset={2}>
                        <WizTable columns={columns} dataSource={dataSource} />
                    </WizCol>
                </WizRow>
            </WizCard>
        )
    }

    _render() {
        let {  ...o } = this.state.record
        let{authData,examTemplateAuthInfo,...other} = this.state.templateAuthInfo ||{}
        let { examTemplateGroupLoading } = this.props;
        return (
            <WizSpin spinning={examTemplateGroupLoading} tip='数据获取中'>
                {this._info(other)}
                {this._target(authData||{})}
                {this._links(examTemplateAuthInfo||{})}
            </WizSpin>
        )
    }
}
const mapStateToProps = (state, ownProps) => {
  const templateAuthInfo = modelUtils.getModelEntity(state['examTemplateGroup'], "templateAuthInfoKey");

    const load = modelUtils.getLoadingState(state, 'examTemplateGroup');
    return { templateAuthInfo, ...load }
};

export default connect(mapStateToProps)(ExamTemplateGroupInfo);
